export default function withBaseUrl(url) {
  let WEBSITE_DOMAIN;
  if (process.env.NEXT_PUBLIC_SITE_URL?.startsWith("localhost")) {
    WEBSITE_DOMAIN = `http://${process.env.NEXT_PUBLIC_SITE_URL}`;
  } else if (process.env.NEXT_PUBLIC_SITE_URL) {
    WEBSITE_DOMAIN = `https://${process.env.NEXT_PUBLIC_SITE_URL}`;
  }  else {
    WEBSITE_DOMAIN = "https://qoncertapp.com";
  }

  return WEBSITE_DOMAIN + url;
}
